// Detects Facebook/Instagram's in-app browser (the sandboxed WebView opened
// when a link is tapped from inside those apps) — a well-documented category
// of problem for Stripe Checkout: its cookie-based anti-fraud checks and 3D
// Secure popups can silently fail inside that WebView, so the card form
// never even loads, with no error surfaced anywhere. Confirmed against real
// data (2026-08-24 non-EUR checkout investigation): every one of the real
// abandoned non-EUR sessions that came from one of these apps had zero
// payment_intent at all — consistent with the checkout page never loading
// properly, not a declined card.
//
// Mirrored server-side in backend/routes/payments.js (IN_APP_BROWSER_UA) for
// the `inAppBrowser` flag recorded on each payment — keep both patterns in
// sync if this one changes.
const IN_APP_BROWSER_UA = /FBAN|FBAV|FB_IAB|Instagram/i;

export function detectInAppBrowser() {
  if (typeof navigator === 'undefined') return { isInApp: false, appName: null, os: 'other' };
  const ua = navigator.userAgent || '';
  const isInApp = IN_APP_BROWSER_UA.test(ua);
  const appName = isInApp ? (/Instagram/i.test(ua) ? 'instagram' : 'facebook') : null;
  const os = /iPhone|iPad|iPod/i.test(ua) ? 'ios' : (/Android/i.test(ua) ? 'android' : 'other');
  return { isInApp, appName, os };
}
